import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAppSelector } from "../store/hooks";
import {
  selectFeaturesError,
  selectFeaturesLoading,
  selectFeaturesStatus,
  selectHasFeature,
} from "../store/roleSlice";

export const FeatureRoute: React.FC<{
  feature: string;
  children: React.ReactElement;
}> = ({ feature, children }) => {
  const loading = useAppSelector(selectFeaturesLoading);
  const error = useAppSelector(selectFeaturesError);
  const status = useAppSelector(selectFeaturesStatus);
  const hasFeature = useAppSelector((state) => selectHasFeature(state, feature));

  const location = useLocation();

  // ✅ Wait for initial load (idle → loading → succeeded/failed)
  if (status === "idle" || loading) {
    return <div style={{ padding: 16 }}>Loading permissions…</div>;
  }

  if (error) {
    return <div style={{ padding: 16 }}>Error loading permissions: {error}</div>;
  }

  if (!hasFeature) {
    return <Navigate to="/no-access" state={{ from: location }} replace />;
  }

  return children;
};
